import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';

/**
 * Send referral type
 */

export const sendReferrals = async (emails: string[], slug: string): Promise<void> => {
    const url = pathfinder('promo_engine_campaigns_notifications_emails', { slug });

    return axios.post(url, { emails });
};
